import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import range from 'lodash/range'

import { s3Upload, s3Delete } from '../libs/awsLib'

import './CreatePage.css'
import { Card, Icon, Loader, Form, Button, Select } from 'semantic-ui-react'
import actions from '../redux/actions'

class CreatePage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      title: '',
      speakerIdentification: false,
      numSpeakers: 2,
      channelIdentification: false,

      file: null,
      s3InputUrl: null,
      s3Key: null,
      fileUploading: false,
      fileUploaded: false
    }
  }

  render () {
    return (
      <div className='CreatePage'>
        <Card fluid>
          <Card.Content>
            <Card.Header>Create a Transcription</Card.Header>
          </Card.Content>

          <Card.Content>
            <div className='CreatePage-section'>
              {this.renderSettings()}
            </div>

            <div className='CreatePage-section'>
              {this.renderFileUpload()}
            </div>
          </Card.Content>

          <Card.Content extra>
            {this.props.isCreating
              ? <div style={{ textAlign: 'center' }}>
                <Loader active inline />
              </div>
              : <div>
                <Button
                  primary
                  floated='left'
                  disabled={!this.validateForm()}
                  onClick={this.startTranscription}
                  >
                    Start Transcription
                  </Button>
                <Button floated='right' negative onClick={this.handleCancel}>
                    Cancel
                  </Button>
              </div>}
          </Card.Content>
        </Card>
      </div>
    )
  }

  renderFileUpload () {
    const { fileUploading, fileUploaded, file } = this.state

    let content
    if (fileUploading && file) {
      content = (
        <div className='CreatePage-upload-status'>
          <Loader size='medium' active>
            <strong>Uploading</strong><br />
            <small>{file.name}</small>
          </Loader>
        </div>
      )
    } else if (fileUploaded && file) {
      content = (
        <div className='CreatePage-upload-complete'>
          <h2><Icon name='check circle' color='green' /></h2>
          <p>
            <strong>Upload complete</strong><br />
            <small>{file.name}</small>
          </p>
        </div>
      )
    } else {
      content = (
        <Dropzone
          className='CreatePage-Dropzone'
          acceptClassName='accept'
          rejectClassName='reject'
          onDropAccepted={this.handleFileChange}
          onDropRejected={this.handleFileRejected}
          allowMultiple={false}
          accept={['audio/mp3', 'audio/mpeg', 'audio/wav']}
        >
          <div className='CreatePage-Dropzone-message'>
            <h2><Icon name='upload' /></h2>
            <h3>Drop file here or click to upload...</h3>
            <p>
              Supported file formats: mp3 & wav
              <br />
              Maximum duration: 120 minutes
            </p>
          </div>
        </Dropzone>
      )
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Field required>
          <label>Upload audio file</label>
          <div>{content}</div>
        </Form.Field>
      </Form>
    )
  }

  renderSettings = () => {
    const {
      title,
      speakerIdentification,
      numSpeakers,
      channelIdentification
    } = this.state

    const { isCreating } = this.props

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Input
          placeholder='Enter a title'
          label='Transcription Title'
          type='text'
          value={title}
          id='title'
          onChange={this.handleTextChange}
          disabled={isCreating}
          required
        />
        <Form.Checkbox
          label='Enable Speaker Identification'
          id='speakerIdentification'
          checked={speakerIdentification}
          onChange={this.handleCheckboxChange}
          disabled={isCreating || this.state.channelIdentification}
        />
        {speakerIdentification &&
          <Form.Field>
            <label>Number of Speakers </label>
            <Select
              id='numSpeakers'
              options={range(2, 11).map(x => ({ value: x, text: `${x}` }))}
              value={numSpeakers}
              onChange={this.handleNumSpeakersChange}
              disabled={isCreating || this.state.channelIdentification}
            />
          </Form.Field>}
        <Form.Checkbox
          label='Enable Channel Identification'
          id='channelIdentification'
          checked={channelIdentification}
          onChange={this.handleCheckboxChange}
          disabled={isCreating || this.state.speakerIdentification}
        />
      </Form>
    )
  }

  validateForm () {
    const { title, s3InputUrl, s3Key, fileUploaded } = this.state
    return [title, s3InputUrl, s3Key, fileUploaded].every(Boolean)
  }

  handleTextChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  handleCheckboxChange = event => {
    this.setState({
      [event.target.id]: event.target.checked
    })
  }

  handleNumSpeakersChange = (event, data) => {
    const parsed = parseInt(data.value, 10)
    let newNumber = isNaN(parsed) ? 2 : parsed

    if (newNumber > 10) {
      newNumber = 10
    } else if (newNumber < 2) {
      newNumber = 2
    }

    this.setState({ numSpeakers: newNumber })
  }

  handleFileChange = async files => {
    const file = files[0]
    if (!file) {
      console.error('No file')
      return
    }

    this.setState({ file, fileUploaded: false, fileUploading: true })

    let result
    try {
      result = await s3Upload(files[0])
    } catch (e) {
      console.error(e)
      alert('File upload failed')

      this.setState({
        file: null,
        s3InputUrl: null,
        s3Key: null,
        fileUploading: false,
        fileUploaded: false
      })

      return
    }

    this.setState({
      s3InputUrl: result.s3InputUrl,
      s3Key: result.s3Key,
      fileUploading: false,
      fileUploaded: true
    })
  }

  handleFileRejected = () => {
    alert('File type not supported')
  }

  handleSubmit = event => {
    event.preventDefault()
  }

  handleCancel = () => {
    if (this.state.s3Key) {
      s3Delete(this.state.s3Key)
    }

    this.props.history.push('/app')
  }

  startTranscription = async event => {
    try {
      await this.createTranscription()
      this.props.history.push('/app')
    } catch (e) {
      alert('Uh oh, something went wrong.')
      console.error(e)
    }
  }

  createTranscription = () => {
    const { file } = this.state

    let format
    if (/mp3/i.test(file.type)) {
      format = 'mp3'
    } else if (/wav/i.test(file.type)) {
      format = 'wav'
    } else {
      format = 'mp3'
    }

    return this.props.create({
      title: this.state.title,
      s3InputUrl: this.state.s3InputUrl,
      s3Key: this.state.s3Key,
      channelIdentification: this.state.channelIdentification,
      speakerIdentification: this.state.speakerIdentification,
      numSpeakers: this.state.numSpeakers,
      format
    })
  }
}

const mapStateToProps = state => ({
  isCreating: state.transcriptions.isCreating
})

const mapDispatchToProps = dispatch => ({
  create: data => dispatch(actions.transcriptions.create(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(CreatePage)



// WEBPACK FOOTER //
// ./src/containers/CreatePage.js